import { useState } from "react";
import { api } from "../../lib/api";
import StatusBadge from "../../components/StatusBadge";
import { PageLoading, ErrorState } from "../../components/States";
import { fmtDateTime } from "../../lib/format";
import { useAdminData, SearchBox, FilterSelect, Pager, TableCard, TH } from "./shared";

export default function AdminHosts() {
  const { data, error, page, setPage, filters, setFilters, reload } = useAdminData(api.adminHosts);
  const [q, setQ] = useState("");
  const rows = data?.items || [];

  return (
    <div data-testid="admin-hosts-page">
      <div className="flex flex-wrap gap-3 mb-4">
        <SearchBox value={q} onChange={setQ} onSearch={() => setFilters((f) => ({ ...f, q }))} placeholder="Search hosts…" testid="admin-hosts-search" />
        <FilterSelect value={filters.status || ""} onChange={(v) => setFilters((f) => ({ ...f, status: v }))} label="Status filter" testid="admin-hosts-status"
                      options={[["", "All statuses"], ["active", "Active"], ["suspended", "Suspended"]]} />
      </div>
      {error ? <ErrorState body={error} onRetry={reload} /> : !data ? <PageLoading label="Loading hosts…" /> : (
        <>
          <TableCard testid="admin-hosts-table" empty={rows.length === 0 && "No hosts found."}
            head={<><TH>Host</TH><TH>Listings</TH><TH>Stripe Connect</TH><TH>Status</TH><TH>Joined</TH></>}>
            {rows.map((u) => (
              <tr key={u.user_id} className="border-b border-[#18181B]" data-testid={`admin-host-${u.user_id}`}>
                <td className="p-4"><p className="font-semibold">{u.name}</p><p className="text-xs text-zinc-500">{u.email}</p></td>
                <td className="p-4 text-zinc-300 text-xs">{u.listings_count} total · {u.active_listings} active</td>
                <td className="p-4 text-xs">{u.connect_account ? <span className="text-emerald-400">Connected{u.connect_country ? ` (${u.connect_country})` : ""}</span> : <span className="text-zinc-500">Not connected</span>}</td>
                <td className="p-4">{u.suspended ? <StatusBadge value="restricted" /> : <StatusBadge value="active" />}</td>
                <td className="p-4 text-xs text-zinc-500">{fmtDateTime(u.created_at)}</td>
              </tr>
            ))}
          </TableCard>
          <Pager page={page} total={data.total} pageSize={data.page_size} onPage={setPage} testid="admin-hosts-pager" />
        </>
      )}
    </div>
  );
}
